import React, { useState, useEffect } from 'react';
import { Button, Table, Card, Row, Col, Typography, Select } from 'antd';
import { PlusOutlined } from "@ant-design/icons";
import AddNewActivity from './AccountActivityModal'; // Ensure the correct import path
import { fetchAllActivities } from '../../../services/Service';
import { activityPageColumns, getRowClassName } from '../../../util/columnsConfig';
import { showErrorNotification } from '../../../util/documentConfig';
import activity from '../../../util/labels.json';

const { Title } = Typography;
const { Option } = Select;

const ActivityList = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activities, setActivities] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null); // edit activity
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [defaultPageSize, setDefaultPageSize] = useState(10); // State for default page size
 
  const [pageSize, setPageSize] = useState(10); // Default page size
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    loadActivities(currentPage, pageSize); // Load activities when the component mounts or page size changes
  }, [currentPage, pageSize]);

  const loadActivities = (page, size) => {
    fetchAllActivities(page, size)
      .then(response => {
        if (response.data.content && response.data.content.length > 0) {
          setActivities(response.data.content);
          setTotalRecords(response.data.totalElements);
        } else {
          setActivities([]);
          setTotalRecords(0);
        }
      })
      .catch(error => {
        showErrorNotification(activity.fetchError);
      });
  };

  // Show modal for adding a new activity
  const showModal = () => {
    setSelectedRecord(null); // Reset selection for new entry
    setIsModalVisible(true);
  };

  // Handle creating a new activity
  const handleCreate = (data) => {
    setActivities([...activities, data]);
    setIsModalVisible(false);
    loadActivities(currentPage, pageSize); // Reload activities after creation
  };

  // Handle updating an existing activity
  const handleUpdate = (updatedRecord) => {
    setActivities((prevActivities) =>
      prevActivities.map((activity) =>
        activity.key === updatedRecord.key ? updatedRecord : activity
      )
    );
    setIsModalVisible(false);
    loadActivities(currentPage, pageSize); // Reload activities after update
  };

  // Open modal with selected activity for editing
  const handleEditClick = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  // Handle page change
  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current - 1);
    setPageSize(pagination.pageSize);
    setDefaultPageSize(pagination.pageSize); // Update default page size
  };

  // Dynamic Page Size Options for pagination based on total records
  const getPageSizeOptions = () => {
    // Default options
    const defaultOptions = [5, 10, 20, 50, 100];

    // Determine the highest page size option based on total records
    const maxPageSize = Math.max(totalRecords, 5);

    // Only include the page sizes that are smaller or equal to the max page size
    return defaultOptions.filter(size => size <= maxPageSize);
  };
   return (
    
      <div className="flex-1 p-6 background-light min-h-screen pt-30 overflow-hidden">

{/* Page Heading */}
<h1 className="text-2xl text-primary font-bold ml-0">{activity.activityTitle} </h1>

{/* Button */}
<div className="flex justify-end mb-4">
  <Button
    type="primary"
   icon={<PlusOutlined />}

    onClick={showModal}
    className="text-white border p-4 bg-[var(--color-primary)]"
  >
    {activity.addActivity}
  </Button>
</div>
      {/* Form Layout Using Card & Grid */}
      
 <Card className="w-full pt-4 shadow-lg" style={{ height: '500px' }} headStyle={{ backgroundColor: 'var(--color-primary)', color: 'white' }}>
      {/*<Card className="w-full max-w-4xl pt-4 shadow-lg" style={{ height: '600px' }} headStyle={{ backgroundColor: 'var(--color-primary)', color: 'white' }}>*/}
        <Row gutter={[12, 12]}>

          
          <Col span={24}>
           <Table
              dataSource={activities}
              columns={activityPageColumns(handleEditClick)}
              rowKey="key"
              rowClassName={getRowClassName}
              pagination={{
                current: currentPage + 1,
                pageSize: pageSize,
                total: totalRecords,
                showSizeChanger: true,
                pageSizeOptions: getPageSizeOptions(),
                defaultPageSize: defaultPageSize, // Use the state variable
                position: ['bottomCenter'],
                itemRender: (current, type, originalElement) => {
                  if (type === 'page') {
                    return originalElement;
                  }
                  return null;
                },
             
              }}
              onChange={handleTableChange}
              bordered
              style={{ height: '100%' }}
              scroll={{ y: 350 }}
              columns={activityPageColumns(handleEditClick).map(col => ({
                ...col,
                onHeaderCell: () => ({
                  style: {
                    backgroundColor: 'var(--color-primary)',
                    color: 'white',
                    fontWeight: 'bold',
                    position: 'sticky',
                    top: 0,
                  },
                }),
              }))}
            />
            
          </Col>
            
        </Row>
      </Card>

      {/* Add/Edit Modal */}
      {isModalVisible && (
        <AddNewActivity
          visible={isModalVisible}
          setVisible={setIsModalVisible}
          onCreate={handleCreate}
          onUpdate={handleUpdate}
          selectedRecord={selectedRecord}
          activity={activity} // Pass selected record for editing
        />
      )}
    </div>
  );
};

export default ActivityList;